import styled from 'styled-components';

export const Wrapper = styled.div`
  line-height: 0;
`;

export const Image = styled.img``;
